"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponentThemes = require("../../_nextgen/packages/styled-component-themes");
var _Link = _interopRequireDefault(require("../Link"));
var _MediaComponent = _interopRequireDefault(require("../MediaComponent"));
var _PriceFormat = _interopRequireDefault(require("../PriceFormat"));
var _Text = _interopRequireDefault(require("../Text"));
var _analytics = _interopRequireWildcard(require("../analytics"));
var Styled = _interopRequireWildcard(require("./ModelTile/index.styled"));
var Themes = _interopRequireWildcard(require("./ModelTile/index.themes"));
var _jsxRuntime = require("react/jsx-runtime");
const Jelly = function (props) {
  var _jelly$image, _jelly$image2, _jelly$image2$desktop;
  const themeContext = (0, _styledComponentThemes.useTheme)();
  const theme = typeof themeContext === "string" ? themeContext : themeContext === null || themeContext === void 0 ? void 0 : themeContext.theme;
  const {
    jelly,
    jellyLabelError,
    ghostJellyImage
  } = props;
  if (jelly !== null && jelly !== void 0 && (_jelly$image = jelly.image) !== null && _jelly$image !== void 0 && _jelly$image.desktop) jelly.image.desktop.alt = "";
  if (!jelly || jelly !== null && jelly !== void 0 && (_jelly$image2 = jelly.image) !== null && _jelly$image2 !== void 0 && (_jelly$image2$desktop = _jelly$image2.desktop) !== null && _jelly$image2$desktop !== void 0 && _jelly$image2$desktop.errorSrc) {
    var _ghostJellyImage$imag, _ghostJellyImage$imag2, _ghostJellyImage$imag3, _ghostJellyImage$imag4, _ghostJellyImage$imag5, _ghostJellyImage$imag6, _ghostJellyImage$imag7;
    const hasGhostImage = !!(ghostJellyImage !== null && ghostJellyImage !== void 0 && (_ghostJellyImage$imag = ghostJellyImage.image) !== null && _ghostJellyImage$imag !== void 0 && _ghostJellyImage$imag.desktop);
    const jellyError = {
      image: {
        desktop: {
          src: ghostJellyImage === null || ghostJellyImage === void 0 ? void 0 : (_ghostJellyImage$imag2 = ghostJellyImage.image) === null || _ghostJellyImage$imag2 === void 0 ? void 0 : (_ghostJellyImage$imag3 = _ghostJellyImage$imag2.desktop) === null || _ghostJellyImage$imag3 === void 0 ? void 0 : _ghostJellyImage$imag3.src,
          alt: (ghostJellyImage === null || ghostJellyImage === void 0 ? void 0 : (_ghostJellyImage$imag4 = ghostJellyImage.image) === null || _ghostJellyImage$imag4 === void 0 ? void 0 : (_ghostJellyImage$imag5 = _ghostJellyImage$imag4.desktop) === null || _ghostJellyImage$imag5 === void 0 ? void 0 : _ghostJellyImage$imag5.alt) || jellyLabelError,
          errorSrc: ghostJellyImage === null || ghostJellyImage === void 0 ? void 0 : (_ghostJellyImage$imag6 = ghostJellyImage.image) === null || _ghostJellyImage$imag6 === void 0 ? void 0 : (_ghostJellyImage$imag7 = _ghostJellyImage$imag6.desktop) === null || _ghostJellyImage$imag7 === void 0 ? void 0 : _ghostJellyImage$imag7.src
        }
      }
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.JellyError, {
      "data-testid": "Jelly",
      children: [hasGhostImage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaComponent.default, {
        ...jellyError
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.JellyLabelError, {
        children: jellyLabelError
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Jelly, {
    "data-testid": "Jelly",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaComponent.default, {
      ...jelly
    })
  });
};
const SpecsShown = function (props) {
  const {
    specs,
    specsShown,
    specsShownError
  } = props;
  if (!specsShown || (specsShown === null || specsShown === void 0 ? void 0 : specsShown.length) === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.SpecsError, {
      "data-testid": "SpecsShown",
      children: specsShownError
    });
  }
  const singleSpec = (specsShown === null || specsShown === void 0 ? void 0 : specsShown.length) === 1;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Specs, {
    $singleSpec: singleSpec,
    "data-testid": "SpecsShown",
    children: specsShown === null || specsShown === void 0 ? void 0 : specsShown.map(function (spec, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.Spec, {
        $singleSpec: singleSpec,
        "data-testid": "SpecsShown",
        children: [spec.key === "msrp" && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.SpecValue, {
          "data-testid": `model-tile-spec-value-${index}`,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PriceFormat.default, {
            price: specs[spec.key]
          })
        }) || /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.SpecValue, {
          "data-testid": `model-tile-spec-value-${index}`,
          children: specs[spec.key]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.SpecName, {
          "data-testid": `model-tile-spec-name-${index}`,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            children: spec.name
          })
        })]
      }, spec.key);
    })
  });
};
const JellyDisclaimer = function (props) {
  const {
    jellyDisclaimer,
    jellyDisclaimerCopy
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.JellyDisclaimer, {
    "data-testid": "model-tile-jelly-disclaimer",
    children: jellyDisclaimer && /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.JellyDisclaimerContent, {
      children: [jellyDisclaimerCopy, " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        children: jellyDisclaimer
      })]
    })
  });
};
const ModelTile = function (props) {
  const {
    name,
    jelly,
    specs,
    specsShown,
    onClick,
    linkProps,
    asShown,
    jellyDisclaimerCopy = "VEHICLE SHOWN AS",
    jellyDisclaimer,
    ghostJellyImage,
    topLabel
  } = props;
  const themeContext = (0, _styledComponentThemes.useTheme)();
  const theme = typeof themeContext === "string" ? themeContext : themeContext === null || themeContext === void 0 ? void 0 : themeContext.theme;
  const fireAnalytics = (0, _analytics.default)("ModelTile", {});
  const handleOnClick = function () {
    if (onClick) onClick();
    window.scrollTo(0, 0);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: props === null || props === void 0 ? void 0 : props.className,
    "data-testid": "ModelTile",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Tile, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.ModelTile, {
        children: [topLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.TopLabel, {
          children: topLabel
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Jelly, {
          jelly: jelly,
          jellyLabelError: "IMAGE UNAVAILABLE",
          ghostJellyImage: ghostJellyImage
        }), linkProps && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.TileLink, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
            onClick: handleOnClick,
            "aria-label": `Select Model - ${name}`,
            ...linkProps
          })
        }), asShown && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.AsShown, {
          "data-testid": "model-tile-asShown",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            children: asShown
          })
        }), name && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Name, {
          "data-testid": "model-tile-name",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            children: name
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SpecsShown, {
          specs: specs,
          specsShown: specsShown,
          specsShownError: "PRICE UNAVAILABLE"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(JellyDisclaimer, {
          jellyDisclaimer: jellyDisclaimer,
          jellyDisclaimerCopy: jellyDisclaimerCopy
        })]
      })
    })
  });
};
const ThemedModelTile = (0, _styledComponentThemes.withThemes)(ModelTile, Themes);
var _default = exports.default = /*#__PURE__*/_react.default.memo((0, _analytics.withAnalytics)(ThemedModelTile)({}));